import { JetView } from 'webix-jet'; // Importing JetView from webix-jet framework
import PlayersView from 'views/players'; // Importing PlayersView component
import FilterFlujoCaja from 'views/cash/flujocaja/filterFlujoCaja'; // Importing FilterFlujoCaja component
import TableFlujoCaja from 'views/cash/flujocaja/tableFlujoCaja'; // Importing TableFlujoCaja component
import DetailsFlujoCaja from 'views/cash/flujocaja/detailsFlujoCaja'; // Importing DetailsFlujoCaja component
import RecordFlujoCaja from 'views/cash/flujocaja/recordFlujoCaja'; // Importing RecordFlujoCaja component
import { devConfig } from 'config/config'; // Importing development configuration

/**
 * Class representing the flujoCajaView.
 * @extends JetView
 */
export default class flujoCajaView extends JetView {
    /**
     * Configures the view layout and components.
     * @returns {Object} The configuration object for the view.
     */
    config() {
        const _ = this.app.getService('locale')._; // Localization service
        const theme = this.app.config.theme; // Current theme configuration
        const screen = this.app.config.size; // Screen size configuration

        const right = {
            // Right side layout configuration
            type: 'wide',
            minWidth: 200,
            rows: [PlayersView, DetailsFlujoCaja, RecordFlujoCaja], // Components in the right section
        };

        const toolbar = {
            // Toolbar configuration
            view: 'toolbar',
            id: 'toolbar',
            css: 'highlighted_header header6', // CSS classes for styling
            paddingX: 5,
            paddingY: 5,
            height: 40,
            cols: [
                {
                    view: 'pager', // Pager component for navigation
                    id: 'pagerA',
                    template:
                        '{common.first()}{common.prev()}&nbsp; {common.pages()}&nbsp; {common.next()}{common.last()}',
                    autosize: false,
                    height: 35,
                    size: 100000000, // Maximum size for pagination
                },
                {
                    view: 'richselect', // Dropdown for export options
                    name: 'Export',
                    id: 'Export',
                    width: 120,
                    placeholder: _('Exportar'), // Placeholder text
                    options: [
                        { id: '1', value: 'Excel' }, // Excel export option
                        { id: '2', value: 'PDF' }, // PDF export option
                    ],
                    on: {
                        onChange: function (value) {
                            // Event handler for export selection
                            if (value == 1) {
                                // Excel export
                                var table = $$('treetable'); // Reference to the table
                                for (var j = 0; j < table.config.columns.length; j++) {
                                    if (table.config.columns[j].exportType) {
                                        delete table.config.columns[j].format; // Remove format for export
                                    }
                                }
                                this.app.callEvent('export:data', [
                                    // Trigger export event
                                    {
                                        NameReport:
                                            ($$('treetable').count() > 0 ? '' : _('No hay datos - ')) + 'Flujo Caja',
                                        TypeReport: 'Excel',
                                    },
                                ]);
                                webix.toExcel(table, {
                                    // Export to Excel
                                    filename:
                                        'Virtualsoft - ' +
                                        new Date()
                                            .toLocaleString('en-GB', {
                                                hour12: true,
                                            })
                                            .replace(/^(\d{4})-(\d{2})-(\d{2})$/g, '$3/$2/$1')
                                            .replace(/[\/:]/g, '_')
                                            .toUpperCase() +
                                        ' - ' +
                                        ($$('treetable').count() > 0 ? '' : _('No hay datos - ')) +
                                        'Flujo Caja',
                                    ignore: {
                                        Action: true,
                                        detailTittle: true,
                                        ActionTittle: true,
                                    },
                                });
                            } else {
                                if (value == 2) {
                                    // PDF export
                                    this.app.callEvent('export:data', [
                                        {
                                            NameReport:
                                                ($$('treetable').count() > 0 ? '' : _('No hay datos - ')) +
                                                'Flujo Caja',
                                            TypeReport: 'PDF',
                                        },
                                    ]);
                                    webix.toPDF($$('treetable'), {
                                        // Export to PDF
                                        filename:
                                            'Virtualsoft - ' +
                                            new Date()
                                                .toLocaleString('en-GB', {
                                                    hour12: true,
                                                })
                                                .replace(/^(\d{4})-(\d{2})-(\d{2})$/g, '$3/$2/$1')
                                                .replace(/[\/:]/g, '_')
                                                .toUpperCase() +
                                            ' - ' +
                                            ($$('treetable').count() > 0 ? '' : _('No hay datos - ')) +
                                            'Flujo Caja',
                                        autowidth: true,
                                        ignore: {
                                            Action: true,
                                            detailTittle: true,
                                            ActionTittle: true,
                                        },
                                    });
                                }
                            }
                            $$('Export').setValue(''); // Reset export selection
                        }.bind(this),
                    },
                },
            ],
        };

        const left = {
            // Left side layout configuration
            css: 'int-left',
            rows: [
                {
                    view: 'toolbar', // Toolbar for the left section
                    css: theme,
                    elements: [
                        { view: 'label', label: _('Flujo Caja') }, // Title label
                        {
                            type: 'wide',
                            css: 'close-bottom',
                            id: 'button-search',
                            cols: [
                                {
                                    view: 'icon', // Search icon
                                    icon: 'wxi-search',
                                    bottom: 20,
                                    right: 35,
                                    width: 30,
                                    height: 30,
                                    click: () => {
                                        $$('filterPopup').show(); // Show filter popup on click
                                    },
                                },
                            ],
                        },
                        {
                            type: 'wide',
                            css: 'close-bottom',
                            cols: [
                                {
                                    view: 'icon', // Close icon
                                    icon: 'wxi-close',
                                    bottom: 20,
                                    right: 35,
                                    width: 30,
                                    height: 30,
                                    click: () => this.show('/top/dashboard'), // Navigate to dashboard on click
                                },
                            ],
                        },
                    ],
                },
                FilterFlujoCaja, // Filter component
                TableFlujoCaja, // Table component
                toolbar, // Toolbar component
            ],
        };

        webix.ui.fullScreen(); // Set the UI to full screen mode
        return {
            // Return the main configuration object
            id: 'a5',
            type: 'clean',
            view: 'form',
            scroll: 'y',
            rows: [
                {
                    height: 'auto',
                    responsive: 'a5',
                    type: 'wide',
                    cols: [left], // Left column configuration
                },
            ],
        };
    }

    /**
     * Initializes the view and sets up event handlers.
     * @param {Object} grid - The grid component.
     */
    init(grid) {
        webix.ready(function () {
            // Wait for Webix to be ready
            if (screen.width < 500 || screen.height < 500) {
                // Check for small screen size
                var childs = $$('toolbar').getChildViews(); // Get child views of the toolbar
                $$('toolbar').removeView(childs[1]); // Remove the second child view
                $$('pagerA').define('group', 1); // Define pager group
            }
            if (screen.width > 500 && screen.height > 500) {
                // Check for larger screen size
                $$('button-search').hide(); // Hide search button
            }
        });
    }
}

// FILE DOCUMENTED
